var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"relative",class:_vm.customClass,attrs:{"type":_vm.type},on:{"click":function($event){$event.preventDefault();return _vm.onClick($event)}}},[_c('div',{class:{
      'flex flex-grow-0': true,
      'opacity-0': _vm.loading
    }},[_vm._t("default")],2),(_vm.loading)?_c('div',{staticClass:"absolute w-full h-full flex flex-grow-0 items-center justify-center z-10"},[_vm._v(" Loading ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }